import cloneDeep from 'lodash/cloneDeep';

const defaultOdooFieldState = {
  editedFields: {},
};

const odooFieldReducer = (state = defaultOdooFieldState, action) => {
  // We use a deep clone so that we aren't mutating the original state
  let out = cloneDeep(state);
  const { hasManyGroup, rowIndex, fieldName, fieldDetails } = action;

  switch (action.type) {
    case 'SET_CHANGED_FIELD': {
      // Index by a 'hash' unique to an individual field
      const hash = fieldName + hasManyGroup + rowIndex;
      out.editedFields[hash] = {
        fieldName,
        hasManyGroup,
        rowIndex,
        fieldDetails,
      };
      return out;
    }
    case 'DELETE_FIELD_GROUP': {
      const hash = action.fieldGroup.name + action.rowIndex;
      out.editedFields[hash] = {
        hasManyGroup: action.fieldGroup.name,
        rowIndex: action.rowIndex,
        isDeleted: true,
      };
      return out;
    }
    case 'DELETE_FIELD': {
      out.editedFields = Object.fromEntries(Object.entries(out.editedFields).filter(([, value]) => value.fieldName !== action.fieldName));
      return out;
    }
    case 'CLEAR_CHANGED_FIELDS': {
      return {
        ...state,
        editedFields: {},
      };
    }
    default:
      return state;
  }
};

export default odooFieldReducer;
